import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import CalendarPreview from './Preview';
import DateColors from './DateColors';
import FontPropertySelect from './FontPropertySelect';
import { checkPermissionForLevel } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';
import * as ActionTypes from '../../../../constants/ActionTypes';
import MainColorPicker from '../../../widgets/MainColorPicker';
import PresetColorPicker from '../../../widgets/PresetColorPicker';
import { availableFontSizes } from './../../../../constants/availableFonts'

class ThemeCalendar extends Component {
    render() {
        const dateColorLabelProps = {
            selectedLabel: 'Selected',
            availableLabel: 'Available',
            unavailableLabel: 'Unavailable',
            pastDate: 'Past Date',
            noCheckin: 'No check-in',
            noCheckout: 'No check-out'
        };
        return (
            <div className="ThemeCalendar Theme-Content">
                <h1>Calendar</h1>
                <div className="subpages-main-content">
                    <div className="col-xs-12">
                        <div className="spark-panel spark-mar-t-1 spark-panel-buttons row">
                            <div className="spark-panel__content col-lg-5 col-xs-12 col-sm-5">
                                <DateColors
                                    id=""
                                    tagNameName="Date Colors"
                                    tagName="dateColor"
                                    fontData={this.props.calendar.dateColor}
                                    calendar={this.props.calendar}
                                    isDisabled={!this.props.hasPermissionThemesEdit}
                                    type={'color'}
                                    {...dateColorLabelProps}
                                />
                                <br />
                                <DateColors
                                    id=""
                                    tagNameName="Date Background Colors"
                                    useCalendarColorPicker
                                    tagName="dateBackgroundColor"
                                    fontData={this.props.calendar.dateBackgroundColor}
                                    type={'background'}
                                    isDisabled={!this.props.hasPermissionThemesEdit}
                                    calendar={this.props.calendar}
                                    {...dateColorLabelProps}
                                />
                                <br />
                                <div className="FontSize">
                                    <h4>Font Size</h4>
                                    <div className="row">
                                        <FontPropertySelect
                                            label="Date Size"
                                            // rem value left intentionally among px values to ensure backward compatibility
                                            values={['1rem', ...availableFontSizes]}
                                            defaultValue={this.props.calendar.date.textSize}
                                            onChange={this.props.setCalendarThemeValue('calendar.date.textSize')}
                                            isDisabled={false}
                                        />
                                        <FontPropertySelect
                                            label="Price Size"
                                            // rem value left intentionally among px values to ensure backward compatibility
                                            values={['0.7rem', ...availableFontSizes]}
                                            defaultValue={this.props.calendar.inlinePrice.textSize}
                                            onChange={this.props.setCalendarThemeValue('calendar.inlinePrice.textSize')}
                                            isDisabled={false}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="AppliedCode">
                                    <h4>Applied Group Code Indicator</h4>
                                    <div className="row">
                                        <div className="col-lg-2 col-xs-12 col-sm-3">
                                            Color
                                            <PresetColorPicker
                                                color={this.props.calendar.dot.color === '' ? '#587817' : this.props.calendar.dot.color}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onColorChange={this.props.setCalendarThemeValue('calendar.dot.color')}
                                                convertToHex
                                            />
                                        </div>
                                        <div className="col-lg-2 col-xs-12 col-sm-3">
                                            Border
                                            <PresetColorPicker
                                                color={this.props.calendar.dot.border}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onColorChange={this.props.setCalendarThemeValue('calendar.dot.border')}
                                                convertToHex
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div className="Tooltip">
                                    <h4>Tooltip</h4>
                                    <div className="row">
                                        <div className="col-lg-2 col-xs-12 col-sm-3">
                                            Color
                                            <PresetColorPicker
                                                color={this.props.calendar.tooltip.color}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.tooltip.color'
                                                )}
                                                convertToHex
                                            />
                                        </div>
                                        <div className="col-lg-2 col-xs-12 col-sm-3">
                                            Border
                                            <PresetColorPicker
                                                color={this.props.calendar.tooltip.border}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.tooltip.border'
                                                )}
                                                convertToHex
                                            />
                                        </div>
                                        <div className="col-lg-2 col-xs-12 col-sm-3">
                                            Background
                                            <PresetColorPicker
                                                color={this.props.calendar.tooltip.background}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.tooltip.background'
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div className="Spinner">
                                    <h4>Spinner</h4>
                                    <div className="row">
                                        <div className="col-lg-2 col-xs-12 col-sm-3">
                                            Color 1
                                            <PresetColorPicker
                                                color={this.props.calendar.date.selected.spinner.color1}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.date.selected.spinner.color1'
                                                )}
                                                convertToHex
                                            />
                                        </div>
                                        <div className="col-lg-2 col-xs-12 col-sm-3">
                                            Color 2
                                            <PresetColorPicker
                                                color={this.props.calendar.date.selected.spinner.color2}
                                                isDisabled={!this.props.hasPermissionThemesEdit}
                                                onColorChange={this.props.setCalendarThemeValue(
                                                    'calendar.date.selected.spinner.color2'
                                                )}
                                                convertToHex
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-1" />
                            <div className="col-xs-12 col-sm-6">
                                <CalendarPreview
                                    calendarPreview={this.props}
                                    calendar={this.props.calendar}
                                    main={this.props.main}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThemeCalendar.propTypes = {
    children: PropTypes.element
};

ThemeCalendar.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = state => {
    return {
        calendar: state.app.data.theme.calendar.calendar,
        hasPermissionThemesEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        ),
        themeColors: state.app.data.theme.colors
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setCalendarThemeValue: path => {
            return event =>
                dispatch({
                    type: ActionTypes.SET_CALENDAR_THEME_VALUE,
                    path,
                    value: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeCalendar);



// WEBPACK FOOTER //
// ./src/components/pages/theme/calendar/index.js